module.exports = __webpack_public_path__ + "assets/img/img9.dc17f12d.png";